import { Box } from "@mui/material";
import React from "react";

export default function Transactions() {
    return (
        <Box>
            Transactions 
        </Box>
    );
}